import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Popup as SemanticPopup } from 'semantic-ui-react';

import {
  CheckedIcon,
  Container,
  PopupContainer,
  PopupItem,
  Requirement,
} from './styles';

const style = {
  height: '220px',
  marginLeft: '370px',
};

const PasswordPopup = (props) => {
  const {
    isOpen,
    password,
    isReset,
  } = props;

  const charactersCountCheck = useMemo(() => /^.*(?=.{12,}).*$/.test(password));
  const lowerCaseCheck = useMemo(() => /^.*((?=.*[a-z]){1}).*$/.test(password));
  const upperCaseCheck = useMemo(() => /^.*((?=.*[A-Z]){1}).*$/.test(password));
  const numberCheck = useMemo(() => /^.*(?=.*\d).*$/.test(password));
  const specialCharacterCheck = useMemo(() => /^.*((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1}).*$/.test(password));

  return (
    <Container isReset={isReset}>
      <SemanticPopup
        basic
        style={style}
        open={isOpen}
        trigger={<span />}
        content={(
          <PopupContainer>
            Must contain at least
            <PopupItem>
              {charactersCountCheck && <CheckedIcon />}
              <Requirement checked={charactersCountCheck}>12 characters</Requirement>
            </PopupItem>
            <PopupItem>
              {lowerCaseCheck && <CheckedIcon />}
              <Requirement checked={lowerCaseCheck}>1 lower case character</Requirement>
            </PopupItem>
            <PopupItem>
              {upperCaseCheck && <CheckedIcon />}
              <Requirement checked={upperCaseCheck}>1 upper case character</Requirement>
            </PopupItem>
            <PopupItem>
              {numberCheck && <CheckedIcon />}
              <Requirement checked={numberCheck}>1 number</Requirement>
            </PopupItem>
            <PopupItem>
              {specialCharacterCheck && <CheckedIcon />}
              <Requirement checked={specialCharacterCheck}>1 special character</Requirement>
            </PopupItem>
          </PopupContainer>
        )}
      />
    </Container>
  );
};

PasswordPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  password: PropTypes.string.isRequired,
  isReset: PropTypes.bool,
};

PasswordPopup.defaultProps = {
  isReset: false,
};

export default PasswordPopup;
